import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from '@fanfanlo';
import { useRouter } from 'next/router';
interface IMenuItemData{
    name:string
    url:string
}
export const MainPageAddButtons: React.FC = () => {
    const router = useRouter();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const {t} = useTranslation('homepage/components/markets/main-page-add-buttons/content')
    const menuItems:IMenuItemData[] = [
        {
            name:t("content.sub.addScriptByUrl"),
            url:"/listen-editing-market"
        },
        {
            name:t("content.sub.addScriptByText"),
            url:"/add-market-by-text"
        },
        {
            name:t("content.sub.addMarket"),
            url:"/add-market-by-url"
        },
        {
            name:t("content.sub.addMarketByText"),
            url:"/listen-editing-market"
        }
    ]
    return (
        <>
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleClick}
                data-testid="MainPageAddButtons__addButton__01JG2B0072"
                data-test-comment="添加按钮，点击后打开添加菜单，支持添加脚本、市场等"
            >
                {t("content.add")}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                data-testid="MainPageAddButtons__menu__01JG2B0073"
                data-test-comment="添加菜单，包含多个添加选项"
            >
                {menuItems.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            handleClose();
                            router.push(item.url);
                        }}
                        data-testid={`MainPageAddButtons__menuItem__01JG2B0074__${index}`}
                        data-test-comment="菜单项，群组元件，点击后导航到对应页面"
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};